import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { IMG } from "@/lib/images";

const links = [
  { to: "/", label: "Start", testid: "nav-link-home" },
  { to: "/leistungen", label: "Steinteppich", testid: "nav-link-leistungen" },
  { to: "/pu-designboden", label: "PU Designboden", testid: "nav-link-pu" },
  { to: "/projekte", label: "Projekte", testid: "nav-link-projekte" },
  { to: "/kontakt", label: "Kontakt", testid: "nav-link-kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0A0A0A]/95 backdrop-blur-md border-b border-white/10"
          : "bg-[#0A0A0A]/85 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="brand-logo"
            className="flex items-center gap-3 group"
            onClick={() => setOpen(false)}
            aria-label="Linea Bodendesign - Startseite"
          >
            <img
              src={IMG.logo}
              alt="Linea Bodendesign"
              className="h-14 w-auto object-contain transition-transform group-hover:scale-105"
              style={{ filter: "url(#brand-light)" }}
            />
          </Link>

          <nav className="hidden md:flex items-center gap-10">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `relative text-sm tracking-wide transition-colors ${
                    isActive
                      ? "text-white font-semibold after:absolute after:-bottom-2 after:left-0 after:right-0 after:h-[2px] after:bg-brand after:rounded-full"
                      : "text-white/70 hover:text-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/kontakt"
              data-testid="nav-cta-button"
              className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-[#0A0A0A] text-sm tracking-wide hover:bg-brand hover:text-white transition-colors duration-300"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-brand group-hover:bg-white transition-colors" />
              Beratung anfragen
            </Link>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 -mr-2 text-white"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menü"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#0A0A0A] border-t border-white/10"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-${l.testid}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-base ${isActive ? "font-semibold text-brand" : "text-white/80"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/kontakt"
              data-testid="mobile-nav-cta"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center px-5 py-3 rounded-full bg-white text-[#0A0A0A] text-sm font-medium"
            >
              Beratung anfragen
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
